import React, { CSSProperties, ReactNode, useRef } from "react";
import Select, {
	components,
	ValueType,
	InputActionMeta,
	IndicatorProps,
	OptionProps,
	ValueContainerProps,
} from "react-select";

/**
 * custom select styles
 */
const style = {
	control: (base, state) => ({
		...base,
		"&:hover": { borderColor: "#fa7525" },
		appearance: "none",
		border: state["selectProps"]
			? "1px solid #C8C8C8"
			: "1px solid #fa7525",
		// This line disable the blue border
		boxShadow: "none",
	}),
};
// export const selectStyles = {
// 	control: (_provided, state) => {
// 		return {
// 			background: state.selectProps.searchModule
// 				? "#052354"
// 				: state["isDisabled"]
// 				? "#e2e2e2"
// 				: "#fff",
// 			color: "#1a1a1a",
// 			display: "flex",
// 			width: "100%",
// 			// height: state.isMulti ? "auto" : "calc(1.3em + 0.5rem + 2px)",
// 			height: 35,

// 			padding: "0.5rem 0.75rem",
// 			// fontSize: "0.875rem",
// 			fontWeight: 400,
// 			lineHeight: 0.8,
// 			zIndex: 1200,
// 			verticalAlign: "middle",
// 			border:
// 				state.isFocused ||
// 				(!state["isDisabled"] &&
// 					state["selectProps"] &&
// 					state["selectProps"].touched &&
// 					!state["hasValue"])
// 					? "1px solid #2b91fe"
// 					: "1px solid #d2d2d6",
// 			// boxShadow: state.isFocused ? "inset 0 0 4px #1071e5" : "none",
// 			// borderRadius: "4px",
// 			appearance: "none",
// 			minHeight: 35,
// 			borderRadius: "2px",
// 			...state.selectProps.customStyles,
// 		};
// 	},
// 	dropdownIndicator: (provided, state) => ({
// 		...provided,
// 		paddingTop: 0,
// 		paddingBottom: 0,
// 		minHeight: 35,
// 		padding: "4px",
// 	}),
// 	indicatorsContainer: (provided, state) => ({
// 		...provided,
// 		// height: "14px",
// 		// position: "absolute",
// 		// right: 0,
// 		// top: 0,
// 		// display: "none",
// 	}),
// 	indicatorSeparator: (provided) => ({
// 		...provided,
// 		display: "none",
// 	}),
// 	clearIndicator: (provided) => ({
// 		...provided,
// 		paddingTop: 0,
// 		paddingBottom: 0,
// 		minHeight: 35,
// 		// width: "14px",
// 		padding: "2px",
// 		// padding: "3px 0",
// 	}),
// 	loadingIndicator: (provided) => ({
// 		...provided,
// 		color: "#000000",
// 		padding: ".5rem .25rem",
// 		marginRight: 0,
// 	}),
// 	loadingMessage: (provided) => ({
// 		...provided,
// 		paddingTop: ".25rem",
// 		paddingBottom: ".25rem",
// 		fontSize: "0.875em",
// 	}),
// 	menu: (provided, state) => ({
// 		...provided,
// 		marginTop: ".5rem",
// 		marginBottom: 0,
// 		borderRadius: 0,
// 		// marginTop: 0,
// 		// marginBottom: 0,
// 		zIndex: 1200,
// 		backgroundColor: state.selectProps.searchModule
// 			? "#052354"
// 			: provided.backgroundColor,
// 	}),
// 	menuList: (provided, state) => ({
// 		...provided,
// 		paddingTop: 0,
// 		paddingBottom: 0,
// 		backgroundColor: state.selectProps.searchModule
// 			? "#052354"
// 			: provided.backgroundColor,
// 	}),
// 	noOptionsMessage: (provided, state) => ({
// 		...provided,
// 		paddingTop: ".5rem",
// 		paddingBottom: ".5rem",
// 		fontSize: "0.875em",
// 		color: state.selectProps.searchModule ? "#ACD4FF" : provided.color,
// 		backgroundColor: state.selectProps.searchModule && "#0da3b8",
// 	}),
// 	option: (provided, { data, isSelected, selectProps, isFocused }) => {
// 		return {
// 			...provided,
// 			backgroundColor: isSelected ? "#98c1ff" : provided.backgroundColor,
// 			color: data.color ? data.color : provided.color,
// 			fontWeight: data.color ? "800" : provided.fontWeight,
// 			cursor: "pointer",
// 			paddingTop: ".25rem",
// 			paddingBottom: ".25rem",
// 			fontSize: "0.75rem",
// 			// backgroundColor: (selectProps.searchModule && isSelected) ? '#0da3b8' : (selectProps.searchModule && isFocused) ? '#0da3b8' : isSelected ? "#98c1ff" : provided.backgroundColor,
// 			// color: selectProps.searchModule ? "#ACD4FF" : data.color ? data.color : provided.color,
// 			"&:hover": {
// 				backgroundColor: selectProps.searchModule && "#0da3b8",
// 			},
// 		};
// 	},
// 	placeholder: (provided, state) => ({
// 		...provided,
// 		color: "#b3b3b3",
// 		fontSize: ".875rem",
// 		// color: state.selectProps.searchModule ? '#ACD4FF' : "#666666",
// 	}),
// 	input: (provided, state) => {
// 		return {};
// 	},
// 	singleValue: (provided, { getValue, selectProps }) => ({
// 		...provided,
// 		lineHeight: 1,
// 		color: selectProps.searchModule
// 			? "#ACD4FF"
// 			: getValue().length && getValue()[0].color
// 			? getValue()[0].color
// 			: "#1a1a1a",
// 		fontWeight:
// 			getValue().length && getValue()[0].color
// 				? 800
// 				: provided.fontWeight,
// 	}),
// 	multiValue: (provided, { getValue, selectProps }) => ({
// 		...provided,
// 	}),
// 	valueContainer: (provided, state) => ({
// 		...provided,
// 		minHeight: "auto",
// 		flexWrap: "nowrap",
// 		overflowX: "auto",
// 		padding: "0",
// 		// paddingLeft: 0,
// 		// paddingRight: 0,
// 		// color: state.selectProps.searchModule ? '#ACD4FF' : "#666666",
// 	}),
// 	container: (provided) => {
// 		return {
// 			...provided,
// 			padding: 0,
// 			flexGrow: "1",
// 		};
// 	},
// };

/**
 * Dropdown indicator element
 */
const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			{props.selectProps.customDropdownIcon ? (
				props.selectProps.customDropdownIcon
			) : (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={12}
					height={12}
					viewBox="0 0 255 255"
					fill="#495057"
					style={{}}
				>
					<path d="M0 63.75l127.5 127.5L255 63.75z" />
				</svg>
			)}
		</components.DropdownIndicator>
	);
};

/**
 * Clear indicator element
 */
const ClearIndicator = (props) => {
	return (
		<components.ClearIndicator {...props}>
			<svg
				height={17}
				width={17}
				viewBox="0 0 20 20"
				aria-hidden={true}
				style={{ fill: "#cccccc", fontSize: "8px" }}
			>
				<path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
			</svg>
		</components.ClearIndicator>
	);
};

/**
 * Checkbox Option Container
 */
const CheckboxOption = (props) => {
	return (
		<div>
			<components.Option {...props}>
				<div className="form-check">
					<input
						type="checkbox"
						className="form-check-input"
						checked={props.isSelected}
						onChange={() => null}
					/>
					<label
						className="form-check-label"
						style={{ cursor: "pointer" }}
					>
						{props.label}
					</label>
				</div>
			</components.Option>
		</div>
	);
};

/**
 * Checkbox All Select Option
 */
const allOption = {
	label: "Select all",
	value: "*",
};

/**
 * Checkbox Option Container
 */
const ValueContainer = (props) => {
	const { children, ...args } = props;

	const currentValues = args.getValue();
	let selectedCount = currentValues.length;

	if (currentValues.some((val) => val.value === allOption.value)) {
		selectedCount = currentValues.length - 1;
	}
	return (
		<components.ValueContainer {...args}>
			<div style={selectedCount ? {} : { color: "#b3b3b3" }}>
				{selectedCount
					? `${selectedCount} selected`
					: "Choose Option..."}
			</div>
			{/* This element contains the event for opening and closing the select input */}
			{children instanceof Array ? children[1] : null}
		</components.ValueContainer>
	);
};

/**
 * On Multiple Checkbox Select
 */
const onMultiCheckboxSelect = ({
	selected,
	action,
	onMultiChange,
	options,
}) => {
	if (selected !== null && selected instanceof Array && selected.length > 0) {
		if (selected[selected.length - 1].value === allOption.value) {
			return onMultiChange([allOption, ...options]);
		}

		let result = [];
		if (selected.length === options.length) {
			if (selected.includes(allOption)) {
				result = selected.filter(
					(option) => option.value !== allOption.value
				);
			} else if (action === "select-option") {
				result = [allOption, ...options];
			}
			return onMultiChange(result);
		}

		return onMultiChange(selected);
	} else {
		return onMultiChange([]);
	}
};

/**
 * Generic dropdown component
 */

function StyledSelect(props) {
	const {
		touched,
		onBlur,
		placeholder,
		id,
		name = "",
		isSearchable,
		isLoading,
		isDisabled,
		options,
		onChange,
		onInputChange,
		value,
		multi,
		multiCheckbox,
		autoFocus,
		className,
		searchModule,
		filterModule,
		customStyles,
		// calculateValueOnChange,
		customDropdownIcon,
	} = props;
	const imageDivRef = useRef([]);

	// const calculateValue = () => {
	//     if (calculateValueOnChange) {
	//         if (multi || multiCheckbox) {
	//             let updatedValue = value as OptionType[];

	//             if (updatedValue?.length && options.length && updatedValue?.length === options.length) {
	//                 updatedValue = [...updatedValue, allOption]
	//             }
	//             return updatedValue as ValueType<OptionType, IsMulti> || null
	//         } else {
	//             if (value instanceof Array) {
	//                 return options.length ? (options.find((option) => option.value === (value as unknown as OptionType)?.value) || null) : null
	//             }
	//             return options.length ? (options.find((option) => option.value.toString() === value?.toString()) || null) : null
	//         }
	//     }

	//     return value as ValueType<OptionType, IsMulti> || null
	// }

	return (
		<Select
			isMulti={multi || multiCheckbox}
			closeMenuOnSelect={!multiCheckbox}
			hideSelectedOptions={!multiCheckbox}
			placeholder={
				placeholder || onInputChange ? "Type to Search..." : "Select..."
			}
			id={id}
			name={name}
			onBlur={() => onBlur && onBlur(name, true)}
			onChange={(selected, actionMeta) => {
				// MultiSelect
				if (multiCheckbox) {
					onMultiCheckboxSelect({
						selected,
						action: actionMeta.action,
						onMultiChange: (selected) =>
							onChange({ name, value: selected }),
						options,
					});
				} else {
					onChange({ name, value: selected });
				}
			}}
			searchModule={searchModule}
			filterModule={filterModule}
			onInputChange={(value, actionMeta) => {
				onInputChange && onInputChange({ newValue: value, actionMeta });
			}}
			// value={calculateValue()}
			value={value}
			touched={touched}
			options={
				multiCheckbox && options.length
					? [allOption, ...options]
					: options
			}
			autoFocus={autoFocus}
			isSearchable={isSearchable}
			isLoading={isLoading}
			isDisabled={isDisabled}
			loadingMessage={() => "Fetching Data..."}
			components={
				{
					IndicatorSeparator: () => null,
				}
				// !multiCheckbox
				// 	? { DropdownIndicator, ClearIndicator }
				// 	: {
				// 			Option: CheckboxOption,
				// 			ValueContainer,
				// 			DropdownIndicator,
				// 			ClearIndicator,
				// 	  }
			}
			styles={style}
			menuPlacement="auto"
			className={className}
			autoComplete="off"
			customStyles={customStyles || {}}
			imageDivRef={imageDivRef}
			isClearable={true}
			customDropdownIcon={customDropdownIcon}
		/>
	);
}

StyledSelect.defaultProps = {
	touched: false,
	isSearchable: true,
	isLoading: false,
	isDisabled: false,
	options: [],
	multi: false,
	autoFocus: false,
};

export default StyledSelect;
